export default __webpack_public_path__ + "static/media/error.c4da9c4e.svg";